/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Items_Already_In_FolderInputs */



/**
* | output |
* | --- |
* | "Items are already in this folder" |
*
* @param {Spaces_Items_Already_In_FolderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_items_already_in_folder = /** @type {((inputs?: Spaces_Items_Already_In_FolderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Items_Already_In_FolderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Elemente befinden sich bereits in diesem Ordner")
	return /** @type {LocalizedString} */ ("Items are already in this folder")
});